import styled from 'styled-components';

const ReferYourFriendFormStyles = styled.section`
  .form {
    .form-header,
    .form-body,
    .form-footer {
      background: var(--color-sand);
    }

    .form-header {
      padding: 2.5rem 2rem 0;
      text-align: center;

      .heading {
        margin: 0;
      }
    }

    .form-body {
      display: grid;
      column-gap: 1rem;
      row-gap: 1.5rem;
      padding: 3rem 2rem 4rem;
    }

    .form-footer {
      display: flex;
      justify-content: flex-end;
      padding: 0 2rem 3rem;
    }
  }

  @media (min-width: 768px) {
    margin: 1rem 0 0;

    .form {
      width: 100%;
      max-width: 80%;
      margin: 0 auto;

      .form-body {
        grid-template-columns: 1fr 1fr;
        align-items: flex-end;
        column-gap: 2rem;
        row-gap: 2rem;
      }
    }
  }

  @media (min-width: 992px) {
    .form {
      max-width: 80%;
    }
  }

  @media (min-width: 1200px) {
    .form {
      max-width: 80%;

      .form-body {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }
`;

export default ReferYourFriendFormStyles;
